import { createAction, props } from '@ngrx/store';

import { Category, CoreMenuCategory } from '@core/domain/models/category.models';
import { SeoInfo } from '@core/domain/models/seo.models';
import { ProductPublicModels } from '@features/products/product';

// SEO Action types
export const SeoActionTypes = {
    SEO_SET_HEAD: '[SEO] SEO_SET_METAS',
    SEO_SET_HEAD_SUCCESS: '[SEO] SEO_SET_METAS_SUCCESS',
    SEO_HOME_ROUTE_CHANGE: '[SEO] SEO_HOME_ROUTE_CHANGE',
    SEO_SET_LAST_SECTION_TRANSLATED: '[SEO] SEO_SET_LAST_SECTION_TRANSLATED',

    // SEO For Templates:
    SEO_SET_DEFAULT_SEO: '[SEO] SET_DEFAULT_SEO',
    SEO_SET_HOME: '[SEO] SET_HOME',
    SEO_SET_CATEGORY: '[SEO] SET_CATEGORY',
    SEO_SET_LOOKBOOK: '[SEO] SET_LOOKBOOK',
    SEO_SET_PRODUCT: '[SEO] SET_PRODUCT',
    SEO_SET_STORE_LOCATOR: '[SEO] SET_STORE_LOCATOR',
    SEO_SET_MY_ACCOUNT: '[SEO] SET_MY_ACCOUNT',
    SEO_SET_CHECKOUT: '[SEO] SET_CHECKOUT',
    SEO_SET_SHOP_CART: '[SEO] SET_SHOP_CART',
    SEO_SET_GIFT_CARD: '[SEO] SET_GIFT_CARD',
    SEO_SET_ERROR_PAGE: '[SEO] SET_ERROR_PAGE',
    SEO_SET_ORDER_STATUS: '[SEO] SEO_SET_ORDER_STATUS',
    SEO_SET_WW: '[SEO] SET_WW',

    // NOINDEX
    SEO_SET_NOINDEX: '[SEO] SEO_SET_NOINDEX',
    SEO_SET_CATEGORY_NOINDEX: '[SEO] SEO_SET_NOINDEX',
    SEO_SET_NOINDEX_SUCCESS: '[SEO] SEO_SET_NOINDEX_SUCCESS',
};

export const SetHead = createAction(
    SeoActionTypes.SEO_SET_HEAD,
    props<{ title: string; metaDescription?: string; imgSrc?: string; isHome?: boolean }>()
);

export const SetHeadSuccess = createAction(
    SeoActionTypes.SEO_SET_HEAD_SUCCESS
);

export const HomeRouteChange = createAction(
    SeoActionTypes.SEO_HOME_ROUTE_CHANGE
);

// SEO Templates
export const SetDefaultSeo = createAction(SeoActionTypes.SEO_SET_DEFAULT_SEO);

export const SetHomeSeo = createAction(SeoActionTypes.SEO_SET_HOME, props<{ index: number }>());

export const SetCategorySeo = createAction(
    SeoActionTypes.SEO_SET_CATEGORY,
    props<{ categorySeo: SeoInfo; category: Category }>()
);

export const SetLookbookSeo = createAction(
    SeoActionTypes.SEO_SET_LOOKBOOK,
    props<{ category: CoreMenuCategory }>()
);

export const SetProductSeo = createAction(
    SeoActionTypes.SEO_SET_PRODUCT,
    props<{
        product: ProductPublicModels.PublicProduct;
        imgPath: string;
    }>()
);

export const SetStoreLocatorSeo = createAction(SeoActionTypes.SEO_SET_STORE_LOCATOR);

export const SetMyAccountSeo = createAction(
    SeoActionTypes.SEO_SET_MY_ACCOUNT
);

export const SetCheckoutSeo = createAction(
    SeoActionTypes.SEO_SET_CHECKOUT
);

export const SetShopCartSeo = createAction(
    SeoActionTypes.SEO_SET_SHOP_CART
);

export const SetGiftCardSeo = createAction(
    SeoActionTypes.SEO_SET_GIFT_CARD
);

export const SetErrorPageSeo = createAction(
    SeoActionTypes.SEO_SET_ERROR_PAGE
);

export const SetOrderStatus = createAction(
    SeoActionTypes.SEO_SET_ORDER_STATUS
);

export const SetLastSectionTranslated = createAction(
    SeoActionTypes.SEO_SET_LAST_SECTION_TRANSLATED,
    props<{ lastSectionTranslated: string }>()
);

// NOINDEX
export const SetNoindex = createAction(
    SeoActionTypes.SEO_SET_NOINDEX
);

export const SetCategoryNoindex = createAction(
    SeoActionTypes.SEO_SET_CATEGORY_NOINDEX,
    props<{ category: Category }>()
);

export const SetNoIndexSuccess = createAction(
    SeoActionTypes.SEO_SET_NOINDEX_SUCCESS
);

export const SetWorldwideSeo = createAction(
    SeoActionTypes.SEO_SET_WW
);
